import React from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import './Marketing.css';

export default function MarketingLayout({ children, branded = false }) {
  return <div className={branded ? 'home-brand' : undefined}><SiteHeader showWordmark={branded} /><main id="main-content">{children}</main><SiteFooter /></div>;
}
